<div *ngIf="!isValid">
  <div class="error-indicator"></div>
</div>
